import { Flex } from "@chakra-ui/react";
import { CircleChart } from "../circleChart";
import { SectionBox } from "../../../components/sectionBox/SectionBox";
import {
  CategoryImpressionsTable,
} from "../categoryImpressionsTable";
import { TopTopicsType } from "../../../graphqlExternal/generated";
import { DateRangeBox } from "../dateRangeBox";
import { returnRoundedNumber } from "..";

export interface ContentCategoryDistributionProps {
  categoryData: TopTopicsType[];
  startDate: string;
  endDate: string;
}

export const ContentCategoryDistribution = ({
  categoryData,
  startDate,
  endDate,
}: ContentCategoryDistributionProps) => {
  const categoryDataList: TopTopicsType[] = [];

  if (!categoryData) {
    return <> </>;
  }
  categoryData.map((category) => {
    const { __typename, ...categoryInfo } = category;
    categoryDataList.push(categoryInfo);
  });

  const dataTableProps = {
    data: categoryDataList,
    columns: ["Category", "Impression Share"],
  };

  // Transform exampleData to match the expected props
  const transformedData = categoryData.map((edge) => ({
    category: `${edge.topic} (${returnRoundedNumber(edge.impressionShare)}%)`,
    impressions: returnRoundedNumber(edge.impressionShare),
  }));

  return (
    <Flex direction={"column"}>
      <DateRangeBox twoWeeksAgoDate={startDate} endDate={endDate} />
      <Flex>
        <SectionBox
          p={2}
          m={4}
          width="50%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          backgroundColor={"#eef7f7"}
        >
          <CategoryImpressionsTable dataTableProps={dataTableProps} />
        </SectionBox>
        <SectionBox p={2} m={4} pl={30} width={"50%"}>
          <CircleChart transformedData={transformedData} />
        </SectionBox>
      </Flex>
    </Flex>
  );
};
